import React from 'react';
import { MessageCircle, Users, Zap, Shield } from 'lucide-react';

const Community = () => {
  return (
    <section id="community" className="py-32 bg-gradient-to-b from-black via-gray-950 to-black relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13?w=1600"
          alt="Community"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left content */}
          <div>
            <span className="text-teal-400 text-sm uppercase tracking-widest font-semibold mb-4 block">
              Inner Circle
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              Comunidad Exclusiva
            </h2>
            <p className="text-xl text-gray-400 mb-8 leading-relaxed">
              Acceso a un grupo privado en WhatsApp para hablar con los emprendedores, compartir avances y recibir feedback en tiempo real.
            </p>
            <p className="text-2xl text-white font-light mb-12">
              Aquí no compites contra otros;
              <span className="font-semibold bg-gradient-to-r from-teal-400 to-teal-600 bg-clip-text text-transparent"> creces con otros</span>.
            </p>

            {/* Features */}
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="p-3 bg-teal-500/10 rounded-lg border border-teal-500/20">
                  <MessageCircle className="text-teal-400" size={24} />
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-1">Acceso Directo</h4>
                  <p className="text-gray-400">Pregunta directamente a emprendedores y recibe respuestas en horas, no días.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="p-3 bg-teal-500/10 rounded-lg border border-teal-500/20">
                  <Users className="text-teal-400" size={24} />
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-1">Red de Pares</h4>
                  <p className="text-gray-400">Conéctate con emprendedores que están en tu misma etapa de crecimiento.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="p-3 bg-teal-500/10 rounded-lg border border-teal-500/20">
                  <Zap className="text-teal-400" size={24} />
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-1">Feedback Rápido</h4>
                  <p className="text-gray-400">Validación inmediata de tus ideas y estrategias antes de implementarlas.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="p-3 bg-teal-500/10 rounded-lg border border-teal-500/20">
                  <Shield className="text-teal-400" size={24} />
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-1">Grupo Privado</h4>
                  <p className="text-gray-400">Espacio confidencial para compartir desafíos y celebrar éxitos.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - WhatsApp mockup */}
          <div className="relative">
            <div className="relative bg-gradient-to-br from-teal-950/30 to-gray-950/30 rounded-3xl p-8 border border-teal-500/20 backdrop-blur-sm">
              {/* Glow effect */}
              <div className="absolute -inset-1 bg-gradient-to-r from-teal-500/20 to-teal-600/20 rounded-3xl blur-xl" />
              
              <div className="relative">
                <div className="bg-gray-900/80 rounded-2xl overflow-hidden border border-white/10">
                  {/* Mock WhatsApp header */}
                  <div className="bg-teal-700 p-4 flex items-center space-x-3">
                    <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                      <Users size={20} className="text-white" />
                    </div>
                    <div>
                      <h5 className="text-white font-semibold">Urpe Founders Circle</h5>
                      <p className="text-teal-100 text-xs">87 miembros</p>
                    </div>
                  </div>

                  {/* Mock messages */}
                  <div className="p-4 space-y-4 bg-gray-950/50">
                    <div className="flex justify-start">
                      <div className="bg-gray-800 rounded-lg rounded-tl-none p-3 max-w-xs">
                        <p className="text-sm text-gray-300">¿Alguien ha validado pricing con encuestas antes de lanzar?</p>
                        <span className="text-xs text-gray-500 mt-1 block">10:23</span>
                      </div>
                    </div>

                    <div className="flex justify-end">
                      <div className="bg-teal-700 rounded-lg rounded-tr-none p-3 max-w-xs">
                        <p className="text-sm text-white">Sí, usé el framework de Van Westendorp. Te paso el template</p>
                        <span className="text-xs text-teal-200 mt-1 block">10:25</span>
                      </div>
                    </div>

                    <div className="flex justify-start">
                      <div className="bg-gray-800 rounded-lg rounded-tl-none p-3 max-w-xs">
                        <p className="text-sm text-gray-300">Perfecto! Gracias 🙏</p>
                        <span className="text-xs text-gray-500 mt-1 block">10:26</span>
                      </div>
                    </div>

                    <div className="flex justify-end">
                      <div className="bg-teal-700 rounded-lg rounded-tr-none p-3 max-w-xs">
                        <p className="text-sm text-white">Este miércoles tenemos sesión sobre pricing strategy con Ricardo</p>
                        <span className="text-xs text-teal-200 mt-1 block">10:28</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Community;
